module.exports = __webpack_public_path__ + "fonts/14c73713-e4df-4dba-933b-057feeac8dd1.d8ee249.woff2";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/AvenirNext/14c73713-e4df-4dba-933b-057feeac8dd1.woff2
// module id = 289
// module chunks = 245 246